export default __webpack_public_path__ + "static/media/tooltip.afcdfcdf.svg";